import { FeathersModel } from './feathersModel'

/**
 * The current user's permissions for a single allocation, as served by the
 * `features/my-permissions` BFF. Modelled as a FeathersModel so it can be loaded through the
 * DataStore-backed `FeathersService.find(MyPermission)` (typed, hydrated, real-time-ready).
 */
export class MyPermission extends FeathersModel {
  static serviceName = 'features/my-permissions'

  allocationId: number
  socialService?: { id: number; name: string }
  location?: { id: number; name: string }
  permissions: { id: number; name: string; description: string; createdAt?: string; updatedAt?: string }[] = []

  updateFromProps(props: Partial<MyPermission>): this {
    super.updateFromProps(props)
    // The backend emits id = allocationId (one row per allocation); guarantee the DataStore identity
    // even if a raw row omits id.
    this.id = this.id ?? this.allocationId
    // FeathersModel.updateFromProps nulls empty arrays — keep permissions a real array.
    this.permissions = this.permissions ?? []
    return this
  }
}
